module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/scotch@3x_3acc48.jpg";